/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoFocusHighlight implements angular.IDirective {
        private window: angular.IWindowService;
        restrict = "A";
        scope = {
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            element.on("click", function() {
                if (window.getSelection().toString) {
                    this.setSelectionRange(0, this.value.length);
                }
            })
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoFocusHighlight();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoFocusHighlight", MeevoFocusHighlight.factory());
}